/**
 * key 运行时（S7）的文案。命名空间 `visualGameAdmin.llm.runtime.*`。
 *
 * 页面上不写解释（版式规范 一）：审计队列丢没丢数据由 Stat 的红色说，冷却还剩多久由倒计时说，
 * 用量是本副本的进程内存 —— 这条只进表头列名和 `title`（`table.usageScope`），不占版面。
 *
 * `en` 与 `zh` 的 key 集必须逐字相同 —— `test/i18n.test.js` 拍平后逐项比对六个语种
 * （`ja`/`es`/`id`/`pt` 是 `structuredClone(en)` 的桩，自动跟随）。
 */

export const en = {
  title: 'Key runtime',
  refresh: {
    now: 'Refresh',
    updatedAt: 'Updated {time}',
  },
  keys: {
    title: 'Key pool',
  },
  table: {
    vendor: 'Provider',
    label: 'Key',
    masked: 'Secret',
    health: 'State',
    concurrency: 'Active / limit',
    saturation: 'Saturation',
    tpm: 'TPM',
    rpm: 'RPM',
    cooldown: 'Cooldown',
    authFailures: 'Auth fails',
    authFailuresHint: 'Last 24 hours',
    usage: 'Usage',
    usageHint: 'This replica only',
    usageScope: 'This replica’s process memory; resets on restart. Active requests / cooldown / TPM / RPM come from Redis.',
    actions: 'Actions',
  },
  health: {
    authFailing: 'Failing auth',
    cooling: 'Cooling down',
    saturated: 'Near limit',
    healthy: 'Healthy',
  },
  values: {
    none: '—',
  },
  actions: {
    clearCooldown: 'Clear cooldown',
    disable: 'Disable',
    confirmClearCooldown: 'Back into rotation now?',
    confirmDisable: 'Disable this key?',
  },
  toast: {
    cooldownCleared: 'Cooldown cleared.',
    disabled: 'Key disabled.',
    failed: 'Action failed.',
  },
  empty: {
    title: 'No enabled key in the pool',
    action: 'Open providers',
  },
  audit: {
    title: 'Audit queue',
    queued: 'Queued rows',
    queuedBytes: 'Queued bytes',
    overflow: 'Dropped (overflow)',
    retryCount: 'Write retries',
  },
}

export const zh = {
  title: 'API Key 状态',
  refresh: {
    now: '刷新',
    updatedAt: '更新于 {time}',
  },
  keys: {
    title: 'API Key',
  },
  table: {
    vendor: '厂商',
    label: 'API Key',
    masked: '脱敏串',
    health: '状态',
    concurrency: '处理中 / 并发上限',
    saturation: '饱和度',
    tpm: 'TPM',
    rpm: 'RPM',
    cooldown: '冷却剩余',
    authFailures: '认证失败',
    authFailuresHint: '最近 24 小时',
    usage: '用量',
    usageHint: '只是本副本的进程内存',
    usageScope: '本副本的进程内存，重启归零。处理中的请求数 / 冷却 / TPM / RPM 来自 Redis。',
    actions: '操作',
  },
  health: {
    authFailing: '认证失败中',
    cooling: '冷却中',
    saturated: '接近上限',
    healthy: '正常',
  },
  values: {
    none: '—',
  },
  actions: {
    clearCooldown: '清除冷却',
    disable: '停用',
    confirmClearCooldown: '现在放回轮询？',
    confirmDisable: '停用这个 API Key？',
  },
  toast: {
    cooldownCleared: '冷却已清除。',
    disabled: 'API Key 已停用。',
    failed: '操作失败。',
  },
  empty: {
    title: '没有已启用的 API Key',
    action: '去厂商页',
  },
  audit: {
    title: '审计队列',
    queued: '排队中的行',
    queuedBytes: '排队字节数',
    overflow: '溢出丢弃',
    retryCount: '写入重试次数',
  },
}
